import type { TypedTranslationFunction } from "@/lib/next-intl-typed";

export function formatAsDollars(
  numberString: string | number | undefined,
  t?: TypedTranslationFunction<"Shop">,
) {
  // Convert the string to a number and fix it to 2 decimal places
  const number = Number.parseFloat(String(numberString)).toFixed(2);

  if (
    numberString === undefined ||
    Number.parseFloat(String(numberString)) === Number.POSITIVE_INFINITY
  )
    return undefined;

  if (Number.parseFloat(String(numberString)) === 0) return "$0.00";

  // Split the number into whole and decimal parts
  const [wholePart, decimalPart] = number.split(".");

  // Add commas to the whole part
  const formattedWholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const formattedDecimalPart = decimalPart === "00" ? "" : `.${decimalPart}`;

  // Combine the parts and return
  return `$${formattedWholePart}${formattedDecimalPart}`;
}
